import { config } from "/app.config"

export default config.isZeno
  ? [
      {
        path: "/onboarding/",
        name: "onboarding",
        component: () => import("@/views/Onboarding/Onboarding"),
        meta: {
          pageTitle: "Onboarding",
          rule: "owner",
          hideMenu: true,
        },
        children: [
          {
            path: "/onboarding/account/",
            name: "onboarding.account",
            component: () => import("@/views/Onboarding/OnboardingCreateAccount.vue"),
            meta: {
              pageTitle: "Create Account",
              rule: "owner",
              hideMenu: true,
            },
          },
          {
            path: "/onboarding/:accountKey/plan/",
            name: "onboarding.plan",
            component: () => import("@/views/Onboarding/OnboardingChoosePlan.vue"),
            meta: {
              pageTitle: "Choose a plan",
              rule: "owner",
              hideMenu: true,
            },
          },
          {
            path: "/onboarding/:accountKey/station/",
            name: "onboarding.station",
            component: () => import("@/views/Onboarding/OnboardingCreateStation.vue"),
            meta: {
              pageTitle: "Create Station",
              rule: "owner",
              hideMenu: true,
            },
          },
        ],
      },
      {
        path: "/onboarding/recover/",
        name: "onboarding.recover",
        component: () => import("@/views/Onboarding/OnboardingRecoverAccount.vue"),
        meta: {
          pageTitle: "Recover Account",
          rule: "owner",
          hideMenu: true,
        },
      },
    ]
  : []
